module.exports = __webpack_public_path__ + "static/media/ts3.cce71031.png";